import React, { useState } from "react";
import cn from "classnames";
import { useTranslation } from "react-i18next";
import { DownIcon } from "../../icons";
import { useFilterContext } from "../head-bar/filter-context";
import { observer } from "mobx-react-lite";

export const TagGroup = observer(({ title, list = [], name, styles, showAll }) => {
  const { state, setState } = useFilterContext();
  const [isExpanded, setIsExpanded] = useState(showAll || false);
  const { t } = useTranslation();

  const toggle = (id, key) => {
    setState((prev) => {
      const list = prev[key] || [];
      let newList = [];
      if (list.includes(id)) {
        newList = list.filter((locId) => locId !== id);
      } else {
        newList = [...list, id];
      }
      return { [key]: newList };
    });
  };

  const displayedList = isExpanded ? list : list.slice(0, 8);

  return (
    <div className="head-filter-group" style={styles}>
      <div className="head-filter-title">{title}</div>
      <div className="head-filter-list">
        {displayedList.map((item, index) => {
          return (
            <div
              className={cn("filter__tag", {
                "filter__tag--active": state[name]?.includes(item.id),
              })}
              key={index}
              onClick={() => toggle(item.id, name)}
            >
              <span title={item.name}>{item.name}</span>
            </div>
          );
        })}
      </div>
      {list.length > 8 && !showAll && (
        <div className="head-filter-more">
          <div
            className="head-filter-more-label"
            onClick={() => setIsExpanded(!isExpanded)}
          >
            <span>{isExpanded ? t("Browse.hide") : t("Browse.showMore")}</span>
            <DownIcon
              style={{ transform: isExpanded ? "rotate(180deg)" : "none" }}
            />
          </div>
          <div className="head-filter-more-line"></div>
        </div>
      )}
    </div>
  );
});
